import { cannot } from '@/app/helpers'
import type { ContentAudio, ContentWhatsApp, DripPart } from '@/app/module/campaigns/types'
import type { Action } from '@/app/module/campaigns/types/schemas/actions/all-actions'

import { getActions } from './part-actions'

export type PartVisitor = {
  action?: (action: Action) => void
  audio?: (content: ContentAudio) => void
  whatsapp?: (content: ContentWhatsApp) => void
}

export const walkActions = (actions: Action[] | null | undefined, visitor: PartVisitor): void => {
  actions?.forEach((action) => {
    visitor.action?.(action)

    switch (true) {
      case 'play' in action:
        visitor.audio?.(action.play)
        break
      case 'sendWhatsapp' in action:
        visitor.whatsapp?.(action.sendWhatsapp)
        break
      case 'makeAPIRequest' in action:
      case 'finishFlow' in action:
      case 'hangup' in action:
      case 'pickUp' in action:
      case 'jump' in action:
      case 'replayQuestion' in action:
      case 'resendQuestion' in action:
      case 'runQuota' in action:
      case 'sendEmail' in action:
      case 'sendSMS' in action:
      case 'sendSMSToPhoneNumbers' in action:
      case 'subscribeToCampaign' in action:
      case 'topup' in action:
      case 'transfer' in action:
      case 'unsubscribe' in action:
      case 'unsubscribeAll' in action:
      case 'updateContact' in action:
        break
      default:
        cannot(action)
    }
  })
}

// Visits direct media content, then stored actions regardless of branch conditions or enabled flags.
// Content callbacks receive translations on the original content object, without separate translation visits.
export const walkPart = (part: DripPart, visitor: PartVisitor): void => {
  switch (true) {
    case 'voiceMessage' in part:
      visitor.audio?.(part.voiceMessage.audio)
      break
    case 'voiceQuestion' in part:
      visitor.audio?.(part.voiceQuestion.audio)
      if (part.voiceQuestion.processingReply) visitor.audio?.(part.voiceQuestion.processingReply)
      break
    case 'whatsappMessage' in part:
      visitor.whatsapp?.(part.whatsappMessage.message)
      break
    case 'whatsappQuestion' in part:
      visitor.whatsapp?.(part.whatsappQuestion.message)
      break
    case 'smsMessage' in part:
    case 'smsQuestion' in part:
    case 'actionsOnly' in part:
    case 'quotaActions' in part:
    case 'apiCall' in part:
    case 'topup' in part:
      break
    default:
      cannot(part)
  }

  walkActions(getActions(part), visitor)
}
